import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import store from '../store'

import router from '../router'

axios.defaults.withCredentials = true

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API // api 的 base_url
})

// request拦截器
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
         * code为非20000是抛错 可结合自己业务进行修改
         */
    const res = response.data
    const resStatus = response.status
    if (resStatus !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error('error'))
    } else {
      if (res.code !== '00') {
        // 02是登录失败
        // 先这样用if了，等之后处理完各种情况再来改这里
        if (res.code === '02') {
          MessageBox.confirm(
            '你已被登出，可以取消继续留在该页面，或者重新登录',
            '确定登出', {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).then(() => {
            store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          })
        } else {
          // 除了后端崩了，返回全是200，具体业务上的问题全靠code来处理
          // 所以这里加一个
          Message({
            message: res.msg,
            type: 'error',
            duration: 5 * 1000
          })
          if (res.msg == '登录状态已过期') {
            store.dispatch('LogOut').then(() => {
              router.push({ path: `/login` })
            })
          }
        }
      } else {
        return response.data
      }
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
